import axios from 'axios';
import { doc, getDoc, updateDoc, collection } from 'firebase/firestore';
import { db, auth } from './firebase';
import { fetchPassageHtml } from './utils/scripture';

export const GET_CHAPTER = 'GET_CHAPTER';
export const GET_SCRIPTURE_FAILURE = 'GET_SCRIPTURE_FAILURE';
export const GET_NAME = 'GET_NAME';
export const GET_NAME_FAILURE = 'GET_NAME_FAILURE';
export const SET_LOGGED_IN = 'SET_LOGGED_IN';
export const SET_LOGGED_OUT = 'SET_LOGGED_OUT';
export const LOADING = 'LOADING';
export const SET_PROFILE_PIC = 'SET_PROFILE_PIC';
export const GET_PROFILE_PIC = 'GET_PROFILE_PIC';

export const getName = (userId) => async dispatch => {
  if (!userId) return;
  try {
    const userDoc = await getDoc(doc(db, 'users', userId));
    if (userDoc.exists()) {
      dispatch({ type: GET_NAME, payload: userDoc.data() });
    }
  } catch (err) {
    dispatch({ type: GET_NAME_FAILURE, payload: 'Could not load user.' });
  }
};

export const getProfilePic = (userId) => async dispatch => {
  if (!userId) return;
  try {
    const userDoc = await getDoc(doc(db, 'users', userId));
    if (userDoc.exists()) {
      dispatch({ type: GET_PROFILE_PIC, payload: userDoc.data().profile_pic_url });
    }
  } catch (err) {
    console.log(err);
  }
};

// Resolves true on success, false otherwise, so callers can show feedback.
export const uploadProfilePic = () => async dispatch => {
  const userId = auth.currentUser?.uid || localStorage.getItem('user_id');
  const input = document.querySelector('input.upload-img') || document.querySelector('input[type="file"]');
  const files = input?.files;
  if (!userId || !files || !files[0]) return false;
  const formData = new FormData();
  formData.append('file', files[0]);
  formData.append('upload_preset', 'ipbfll99');
  try {
    const res = await axios.post('https://api.Cloudinary.com/v1_1/chaqar-bible-app/image/upload', formData);
    const url = res.data.secure_url;
    await updateDoc(doc(db, 'users', userId), { profile_pic_url: url });
    dispatch({ type: SET_PROFILE_PIC, payload: url });
    return true;
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const getChapter = (book, chapter) => dispatch => {
  dispatch({ type: LOADING });
  fetchPassageHtml(`${book}.${chapter}`, {
    'content-type': 'html',
    'include-notes': 'false',
    'include-titles': 'true',
    'include-chapter-numbers': 'false',
    'include-verse-numbers': 'true',
    'include-verse-spans': 'false',
    'use-org-id': 'false',
  })
    .then(content => {
      dispatch({ type: GET_CHAPTER, payload: content });
    })
    .catch(err => {
      dispatch({ type: GET_SCRIPTURE_FAILURE, payload: 'Could not load scripture.' });
    });
};

export const setLoggedIn = () => dispatch => {
  dispatch({ type: SET_LOGGED_IN });
};

export const setLoggedOut = () => dispatch => {
  dispatch({ type: SET_LOGGED_OUT });
};
